import React from 'react'
import { TableCell } from '@mui/material'
import makeStyles from '@mui/styles/makeStyles'
import classNames from 'classnames'

import type { InvoiceLineItem } from '~/types'

import { formatMoneyRange, getExtendedPrice } from '../../invoiceUtils'

const useStyles = makeStyles(
  () => ({
    extendedCell: {
      width: 120,
    },
  }),
  { name: 'ExtendedPriceCellBody' },
)

export interface ExtendedPriceCellBodyProps {
  className?: string
  hidePrice?: boolean
  isDeclined: boolean
  item: InvoiceLineItem
}

const ExtendedPriceCellBody = ({
  isDeclined,
  item,
  hidePrice = false,
  className,
}: ExtendedPriceCellBodyProps) => {
  const classes = useStyles()

  const extendedPrice = getExtendedPrice(item)

  const showPrice = !isDeclined && !hidePrice

  return (
    <TableCell
      align="right"
      className={classNames(className, classes.extendedCell)}
    >
      {showPrice && formatMoneyRange(extendedPrice)}
    </TableCell>
  )
}

export default ExtendedPriceCellBody
